import { Subscription } from 'rxjs/Rx';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Color } from '../../../models/color.model';
import { VisualizerService } from '../../../services/visualizer.service';
import { forEach } from '@angular/router/src/utils/collection';
import { WoodTypeEnum } from '../../../models/wood-type';
import { StartupService } from '../../../services/startup.service';
import { QuestionTypeEnum } from '../../../models/question-type';
import { QaService } from '../../../services/qa.service';
import { Empty } from '../../../models/utils.model';
import { AnswerInfoService } from '../../../services/answer-info.service';

@Component({
  selector: 'app-color',
  templateUrl: './color.component.html',
  styleUrls: ['./color.component.scss']
})
export class ColorComponent implements OnInit, OnDestroy {
  @Input() public simpleColor: Color;
  @Input() public opacity: number;
  @Input() public opacityName: string;
  constructor(
    private colorService: VisualizerService,
    private startupService: StartupService,
    private qaService: QaService,
    private answerInfoService: AnswerInfoService
  ) { }

  ngOnInit() {

  }

  onColorClick() {
    this.simpleColor.IsSelected = true;
    this.simpleColor.OpacityName = this.opacityName;
    this.focusProperColor(this.simpleColor);
    this.colorService.setSelectedColor(this.simpleColor);
  }

  focusProperColor(selectedColor: Color) {
    const colorGroups = this.colorService.visualizerData.ColorGroups;
    for (const group of colorGroups) {
      for (const colorArray of group.OpacityColors) {
        for (const color of colorArray) {
          if (selectedColor.ItemGUID === color.ItemGUID) {
            color.IsSelected = true;
          } else {
            color.IsSelected = false;
          }
        }
      }
    }
  }


  public checkElite() {
    if (window.location.href.split('/')[3] === 'en-us') {
      return true && this.getOptionalEliteWoodType();
    } else if (window.location.href.split('/')[3] === 'en-ca' || window.location.href.split('/')[3] === 'fr-ca') {
      return false;
    }
  }

  public checkSummit() {
    if (window.location.href.split('/')[3] === 'en-us') {
      return false;
    } else if (window.location.href.split('/')[3] === 'en-ca' || window.location.href.split('/')[3] === 'fr-ca') {
      return true && this.getOptionalEliteWoodType();
    }
  }

  // Only pressure treated wood should show the 'E' on the color swatches for elite colors
  public getOptionalEliteWoodType() {
    const elitePTL = this.answerInfoService.getWoodTypeGuid(WoodTypeEnum.PressureTreated);
    const eliteCedar = this.answerInfoService.getWoodTypeGuid(WoodTypeEnum.Cedar);
    // || this.answerInfoService.getSelectedWoodType() === eliteCedar
    if (this.answerInfoService.getSelectedWoodType() === elitePTL) {
      return true;
    }
    return false;
  }

  ngOnDestroy() {
    //
  }
}



// WEBPACK FOOTER //
// ./src/app/components/visualizer/color/color.component.ts